import React from "react";
import styled from "styled-components";
import "styled-components/macro";
import * as mq from "../styles/mediaQueries";

function Footer() {
  return (
    <Section>
      <div>
        <p
          css={`
            font-weight: normal;
            font-size: 1.1em;
            color: #858c97;
          `}
        >
          © 2021 copyright all right reserved
        </p>
      </div>
    </Section>
  );
}

export default Footer;
const Section = styled.div`
  padding-top: 3.9em;
  display: flex;
  justify-content: center;

  ${mq.sm} {
    padding-top: 3em;
  }
`;
